import React from 'react';
type BookCoverProps = {
  kicker: string;
  title: string;
  subtitle: string;
  image: string;
  className?: string;
};
export function BookCover({
  kicker,
  title,
  subtitle,
  image,
  className = ''
}: BookCoverProps) {
  return <div className={`relative aspect-[3/4] overflow-hidden rounded-sm border border-white/10 bg-club shadow-[0_20px_40px_rgba(0,0,0,0.6)] ${className}`} data-id="element-34" data-mp="2x4s0lyc8161i">
      <img src={image} alt="" loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-60" data-id="element-35" data-mp="2o66j86ihjx2b" />
      <div className="absolute inset-0 bg-black/35" data-id="element-36" data-mp="2jdx0bafsfx9j" />
      <div className="absolute inset-y-0 left-0 flex w-2 flex-col justify-around py-1.5 sm:w-3 sm:py-2" aria-hidden="true" data-id="element-37" data-mp="2jd3t68cx35qv">
        {Array.from({
        length: 14
      }).map((_, i) => <span key={i} className="mx-auto h-0.5 w-1.5 rounded-full bg-cream/40 sm:h-1 sm:w-2" data-id="element-38" data-mp="29ilhafxck3vz" data-mpi={i} />)}
      </div>
      <div className="relative flex h-full flex-col items-center px-2 pl-3 pt-[12%] text-center sm:px-4" data-id="element-39" data-mp="24jideyt3s3pl">
        <span className="font-serif text-[0.7em] font-semibold leading-tight text-cream" data-id="element-40" data-mp="19argjfqme1wt">{kicker}</span>
        <span className="font-serif text-[1.25em] font-bold leading-tight text-gold-soft" data-id="element-41" data-mp="1e17rmt6yxbg0">{title}</span>
        <span className="mt-1 font-serif text-[0.7em] font-semibold uppercase leading-tight tracking-wide text-cream" data-id="element-42" data-mp="zcv6kr9f5d0a">
          {subtitle}
        </span>
        <span className="mt-2 h-px w-6 bg-gold/70 sm:w-10" data-id="element-43" data-mp="14bxzxeg1dusf" />
      </div>
    </div>;
}